<template>
  <!-- 轮播图滚动 -->
  <div
    class="lunbotu"
    :class="{
      en: isEn,
    }"
  >
    <div id="SIZE" class="SIZE wow animate__animated animate__fadeInUp">
      <div id="top">{{ $t("home").cooperationPartner.cooperationName }}</div>
    </div>
    <div class="view">
      <!-- 第一页 -->
      <ul class="ulList wow animate__animated animate__fadeInRight">
        <li class="item item15">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488911&idx=1&sn=09150a9798f30c8806410ba5f6fe5262&chksm=fcd15ad8cba6d3ce3930798f991cb5dc2e8d5a04a25cb728ce3697eca3c18cf5b8728d613e2e&token=585583893&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase8_en.jpg"
                alt=""
              />
              <template v-else>
                <p>总结与展望</p>
                <img src="@/static/img/CooperationCase8.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list15.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list15.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item1">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488794&idx=1&sn=e398b5c0114f54da3951578750b5e988&chksm=fcd15a4dcba6d35b736749e54f2852e6deb3d28518cab6c66b4c868fcca1189a927a7c287fd8&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img src="@/static/img/CooperationCase1.png" alt="" />
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list01.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list01.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item4">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488781&idx=1&sn=7dc4a84664513caf180593a02d8a61c6&chksm=fcd15a5acba6d34ce2966485ce3d2a95f33aca098bbf6234edd8e283cb439492a98d049c182f&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase2_en.jpg"
                alt=""
              />
              <template v-else>
                <p>科技型中小企业认定</p>
                <img src="@/static/img/CooperationCase2.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list02.h1 }}
              </div>
              <div id="detail">
                {{ $t("home").cooperationPartner.list02.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item2">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488762&idx=1&sn=104c53b372959bd057c2a6d38f9a0db4&chksm=fcd15badcba6d2bb2c40d88983021f54e0a34ec0e90d6f3111fd03d396fc229a27e2b3998e34&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img src="@/static/img/CooperationCase3.png" alt="" />
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list03.h1 }}
              </div>
              <div id="detail">
                {{ $t("home").cooperationPartner.list03.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item3">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488724&idx=1&sn=a0b7c52f1eb9058bb88e5b883c94ec68&chksm=fcd15b83cba6d2950c79886b9cb0cda0ce41f3b19650a51c7fe115d17d9c66a87a3ef9043897&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase4_en.jpg"
                alt=""
              />
              <template v-else>
                <p>第三届自动驾驶仿真核心技术研讨会</p>
                <img src="@/static/img/CooperationCase4.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list04.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list04.h2 }}
              </div>
            </div>
          </a>
        </li>

        <li class="item item5">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488559&idx=1&sn=1653a14f4043e2b9f7bdfb994dc420cb&chksm=fcd15b78cba6d26e3aedc4f1db5f2a3b0681b6c2de8b9eeaaf59ffe223521cba52c8fe764211&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase5_en.jpg"
                alt=""
              />
              <template v-else>
                <p>荣获优秀企业</p>
                <img src="@/static/img/CooperationCase5.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list05.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list05.h2 }}
              </div>
            </div>
          </a>
        </li>

        <li class="item item6">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488519&idx=1&sn=b8c18b7599b289d6ac6644fa4014f2ca&chksm=fcd15b50cba6d2464f0d34436b9a0f88483a9ddb66ba021490d30738d0a3cbe4f31eb4083c13&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase6_en.jpg"
                alt=""
              />
              <template v-else>
                <p>荣获优胜企业</p>
                <img src="@/static/img/CooperationCase6.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list11.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list11.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item13">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488622&idx=1&sn=a58219b8c244091e08c0b15d80548632&chksm=fcd15b39cba6d22f346694a748eb8574ffebeeaa1da0678e68675e000f674aa2e8d4ba75455b&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img src="@/static/img/CooperationCase7.png" alt="" />
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list13.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list13.h2 }}
              </div>
            </div>
          </a>
        </li>
      </ul>
      <!-- 第二页 -->
      <ul class="ulList wow animate__animated animate__fadeInRight">
        <li class="item item17">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488911&idx=1&sn=09150a9798f30c8806410ba5f6fe5262&chksm=fcd15ad8cba6d3ce3930798f991cb5dc2e8d5a04a25cb728ce3697eca3c18cf5b8728d613e2e&token=585583893&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase8_en.jpg"
                alt=""
              />
              <template v-else>
                <p>总结与展望</p>
                <img src="@/static/img/CooperationCase8.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list15.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list15.h2 }}
              </div>
            </div>
          </a>
        </li>

        <li class="item item7">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488794&idx=1&sn=e398b5c0114f54da3951578750b5e988&chksm=fcd15a4dcba6d35b736749e54f2852e6deb3d28518cab6c66b4c868fcca1189a927a7c287fd8&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img src="@/static/img/CooperationCase1.png" alt="" />
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list06.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list06.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item8">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488781&idx=1&sn=7dc4a84664513caf180593a02d8a61c6&chksm=fcd15a5acba6d34ce2966485ce3d2a95f33aca098bbf6234edd8e283cb439492a98d049c182f&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase2_en.jpg"
                alt=""
              />
              <template v-else>
                <p>科技型中小企业认定</p>
                <img src="@/static/img/CooperationCase2.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list07.h1 }}
              </div>
              <div id="detail">
                {{ $t("home").cooperationPartner.list07.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item9">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488762&idx=1&sn=104c53b372959bd057c2a6d38f9a0db4&chksm=fcd15badcba6d2bb2c40d88983021f54e0a34ec0e90d6f3111fd03d396fc229a27e2b3998e34&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img src="@/static/img/CooperationCase3.png" alt="" />
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list08.h1 }}
              </div>
              <div id="detail">
                {{ $t("home").cooperationPartner.list08.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item10">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488724&idx=1&sn=a0b7c52f1eb9058bb88e5b883c94ec68&chksm=fcd15b83cba6d2950c79886b9cb0cda0ce41f3b19650a51c7fe115d17d9c66a87a3ef9043897&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase4_en.jpg"
                alt=""
              />
              <template v-else>
                <p>第三届自动驾驶仿真核心技术研讨会</p>
                <img src="@/static/img/CooperationCase4.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list09.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list09.h2 }}
              </div>
            </div>
          </a>
        </li>

        <li class="item item11">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488559&idx=1&sn=1653a14f4043e2b9f7bdfb994dc420cb&chksm=fcd15b78cba6d26e3aedc4f1db5f2a3b0681b6c2de8b9eeaaf59ffe223521cba52c8fe764211&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase5_en.jpg"
                alt=""
              />
              <template v-else>
                <p>荣获优秀企业</p>
                <img src="@/static/img/CooperationCase5.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list10.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list10.h2 }}
              </div>
            </div>
          </a>
        </li>

        <li class="item item12">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488519&idx=1&sn=b8c18b7599b289d6ac6644fa4014f2ca&chksm=fcd15b50cba6d2464f0d34436b9a0f88483a9ddb66ba021490d30738d0a3cbe4f31eb4083c13&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img
                v-if="isEn"
                src="@/static/img/CooperationCase6_en.jpg"
                alt=""
              />
              <template v-else>
                <p>荣获优胜企业</p>
                <img src="@/static/img/CooperationCase6.png" alt="" />
              </template>
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list12.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list12.h2 }}
              </div>
            </div>
          </a>
        </li>
        <li class="item item14">
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488622&idx=1&sn=a58219b8c244091e08c0b15d80548632&chksm=fcd15b39cba6d22f346694a748eb8574ffebeeaa1da0678e68675e000f674aa2e8d4ba75455b&token=1457314569&lang=zh_CN#rd"
            target="_blank"
          >
            <div id="img">
              <img src="@/static/img/CooperationCase7.png" alt="" />
            </div>
            <div id="fontContent">
              <div id="FONT" class="fontfirst">
                {{ $t("home").cooperationPartner.list14.h1 }}
              </div>
              <div id="detailShot">
                {{ $t("home").cooperationPartner.list14.h2 }}
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      setTime: null,
    };
  },
  computed: {
    isEn() {
      return this.$i18n.locale == "en-US";
    },
  },
  created() {},
  mounted() {
    // window.onload = function () {
    this.setTime = setTimeout(() => {
      let timer = null;
      const ulEl = document.querySelector(".ulList");
      const view = document.querySelector(".view");
      if (ulEl) {
        let len = ulEl.offsetWidth;
        let x = 0;
        let speed = 0.5; // 速度
        // view.onmouseenter = function () { speed = 0 };
        // view.onmouseleave = function () { speed = 0.5 };
        ulEl.onmouseenter = function () {
          speed = 0;
        };
        ulEl.onmouseleave = function () {
          speed = 0.5;
        };
        // eslint-disable-next-line no-inner-declarations
        function animationStart() {
          timer = setInterval(() => {
            x += speed;
            if (x > len) {
              x = 0;
            }
            view.style = `will-change: transform; transform: translateX(${-x}px)`;
          });
        }
        animationStart();
        document.addEventListener("visibilitychange", function () {
          if (document.visibilityState === "hidden") {
            clearInterval(timer);
          } else {
            animationStart();
          }
        });
      }
    }, 2000);
    // };
    this.$bus.$on("reload", () => {
      window.location.reload();
    });
  },
  methods: {},
  destroyed() {
    // 清除定时器
    clearTimeout(this.setTime);
  },
};
</script>

<style scoped lang="scss">
.lunbotu {
  width: 100%;
  height: 45rem;
  display: flex;
  overflow: hidden;
  padding-bottom: 14rem;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #0c132b;
  background: url("@/static/img/Cooperation.png") no-repeat top left;
  background-size: cover;

  #SIZE {
    top: 7rem;
    margin: auto;
    height: 5.75rem;
    position: relative;

    #top {
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 600;
      text-align: center;
      line-height: 3.125rem;
      // letter-spacing: 0.5rem;
      color: rgba(255, 255, 255, 0.85);
    }

    #button {
      margin-top: 2rem;
      font-size: 1.2rem;
      text-align: center;
      letter-spacing: 20px;
      line-height: 1.625rem;
      color: rgba(255, 255, 255, 0.65);
    }
  }

  .view {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    margin-top: 14rem;

    .ulList {
      padding: 0;
      margin: 0;
      height: 16rem;
      display: flex;
      flex-shrink: 0;
      list-style: none;
      flex-wrap: nowrap;

      a {
        color: white;
        text-decoration: none;
      }

      .item {
        width: 21rem;
        height: 14rem;
        cursor: pointer;
        margin: 0 0.625rem;
        position: relative;
        background: #1d2245;
        border-radius: 0.25rem;
        box-shadow: 5px 1.5rem 1.875rem rgba(12, 12, 12, 0.2);

        #img {
          top: 0;
          width: 21rem;
          height: 8.75rem;
          overflow: hidden;
          position: absolute;
          border-top-left-radius: 0.25rem;
          border-top-right-radius: 0.25rem;

          p {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            z-index: 1;
            color: rgba(255, 255, 255, 0.85);
            text-align: center;
            font-size: 1.16rem;
            font-style: normal;
            font-weight: 600;
          }

          img {
            width: 21rem;
            display: block;
            height: 8.75rem;
            border-top-left-radius: 0.25rem;
            border-top-right-radius: 0.25rem;
            object-fit: cover;
          }
        }

        &:hover img {
          transform: scale(1.1);
          -ms-transform: scale(1.1);
          -o-transform: scale(1.1);
          -moz-transform: scale(1.1);
          -webkit-transform: scale(1.1);
          transition: all 0.5s linear;
        }

        &:not(:hover) img {
          transform: scale(1);
          -ms-transform: scale(1);
          -o-transform: scale(1);
          -moz-transform: scale(1);
          -webkit-transform: scale(1);
          transition: all 0.5s linear;
        }

        #fontContent {
          height: 5.25rem;
          transition: all 0.5s linear;
        }
        &:hover {
          #fontContent {
            height: 7rem;
          }
        }

        //单行文本的
        &:hover #fontContent #detailShot {
          visibility: visible;
          transform: translateY(-2rem);
          transition: all 0.5s linear;
        }

        &:not(:hover) #fontContent #detailShot {
          visibility: hidden;
          transform: translateY(0rem);
          transition: all 0.5s linear;
        }

        //俩行文本的
        &:hover #fontContent #detail {
          visibility: visible;
          transform: translateY(-1.5rem);
          transition: all 0.5s linear;
        }

        &:not(:hover) #fontContent #detail {
          visibility: hidden;
          transform: translateY(0rem);
          transition: all 0.5s linear;
        }

        #fontContent {
          bottom: 0;
          z-index: 2;
          width: 100%;
          height: 5.25rem;
          padding: 1rem 2rem;
          position: absolute;
          /* background: #0822eb; */
          box-sizing: border-box;
          background: #1d2245;
          border-bottom-left-radius: 0.25rem;
          border-bottom-right-radius: 0.25rem;

          #FONT {
            height: 3.5rem;
            overflow: hidden;
            overflow-y: auto;

            /* 设置滚动条的宽度和颜色 */
            &::-webkit-scrollbar {
              width: 0;
            }

            box-sizing: border-box;
            color: white;
            text-align: left;
            font-size: 0.8rem;
            white-space: normal;
            letter-spacing: 10px;
            line-height: 1.625rem;
          }

          .fontfirst {
            box-sizing: border-box;
            color: white;
            text-align: left;
            font-size: 0.88rem;
            letter-spacing: 10px;
            line-height: 1.625rem;
          }

          //单行文本的
          #detailShot {
            bottom: -0.5rem;
            color: rgba(255, 255, 255, 0.45);
            text-align: left;
            font-size: 0.8rem;
            position: absolute;
            letter-spacing: 10px;
            line-height: 1.625rem;
          }

          //俩行文本的
          #detail {
            bottom: -0.5rem;
            color: rgba(255, 255, 255, 0.45);
            text-align: left;
            font-size: 0.8rem;
            position: absolute;
            letter-spacing: 10px;
            line-height: 1.625rem;
          }
        }
      }
    }
  }

  &.en {
    #fontContent {
      #detailShot,
      #detail {
        letter-spacing: 0 !important;
      }
    }
  }
}
</style>
